
import { onMounted, reactive, ref, watch } from "@vue/runtime-core";
import { downloadReport, connectUs } from "@/api/http";
export default {
  name: "connectUs",
  setup() {
    const modalType = ref<number>(0);
    const errStatus = ref<number>(0);
    const formData = reactive({
      company: "",
      email: "",
      name: "",
      mobile: "",
      industry: "",
    });
    const emailErr = () => {
      const myreg =
        /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
      return !myreg.test(formData.email);
    };
    const phoneErr = () => {
      const myreg = /^1(3|4|5|7|8)\d{9}$/;
      return !myreg.test(formData.mobile);
    };
    const ensure = () => {
      if (modalType.value > 1) {
        if (!formData.email || emailErr()) {
          errStatus.value = 2;
        } else {
          errStatus.value = 0;
        }
      } else if (!formData.company) {
        errStatus.value = 1;
      } else if (!formData.email || emailErr()) {
        errStatus.value = 2;
      } else if (!formData.name) {
        errStatus.value = 3;
      } else if (!formData.mobile || phoneErr()) {
        errStatus.value = 4;
      } else {
        errStatus.value = 0;
      }
      if (errStatus.value) {
        return;
      }
      if (modalType.value > 1) {
        const { industry, ...params } = formData;
        downloadReport({ ...params, no: modalType.value }).then((data) => {
          if (data.code === "0") {
            modalType.value = 2;
          }
        });
      } else {
        connectUs(formData).then((data) => {
          if (data.code === "0") {
            modalType.value = 2;
          }
        });
      }
    };

    watch(modalType, () => {
      formData.company = "";
      formData.name = "";
      formData.mobile = "";
      formData.industry = "";
      errStatus.value = 0;
    });
    onMounted(() => {
      document.addEventListener("show_modal", (ev: any) => {
        modalType.value = ev.detail;
      });
    });
    return {
      modalType,
      formData,
      errStatus,
      ensure,
    };
  },
};
